// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LXl_","left":"styles_left__5FNGR"};